"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var DARK_MODE_DEFAULT_FORMAT = {
    backgroundColors: {
        darkModeColor: 'rgb(51,51,51)',
        lightModeColor: 'rgb(255,255,255)',
    },
    textColors: {
        darkModeColor: 'rgb(255,255,255)',
        lightModeColor: 'rgb(0,0,0)',
    },
};
function calculateDefaultFormat(node, baseFormat, inDarkMode) {
    if (inDarkMode) {
        if (!baseFormat.backgroundColors) {
            baseFormat.backgroundColors = DARK_MODE_DEFAULT_FORMAT.backgroundColors;
        }
        if (!baseFormat.textColors) {
            baseFormat.textColors = DARK_MODE_DEFAULT_FORMAT.textColors;
        }
    }
    if (baseFormat && Object.keys(baseFormat).length === 0) {
        return {};
    }
    baseFormat = baseFormat || {};
    var fontFamily = baseFormat.fontFamily, fontSize = baseFormat.fontSize, textColor = baseFormat.textColor, textColors = baseFormat.textColors, backgroundColor = baseFormat.backgroundColor, backgroundColors = baseFormat.backgroundColors, bold = baseFormat.bold, italic = baseFormat.italic, underline = baseFormat.underline;
    var currentStyles = fontFamily && fontSize && (textColor || textColors) ? null : roosterjs_editor_dom_1.getComputedStyles(node);
    return {
        fontFamily: fontFamily || currentStyles[0],
        fontSize: fontSize || currentStyles[1],
        get textColor() {
            return textColors
                ? inDarkMode
                    ? textColors.darkModeColor
                    : textColors.lightModeColor
                : textColor || currentStyles[2];
        },
        textColors: textColors,
        get backgroundColor() {
            return backgroundColors
                ? inDarkMode
                    ? backgroundColors.darkModeColor
                    : backgroundColors.lightModeColor
                : backgroundColor || '';
        },
        backgroundColors: backgroundColors,
        bold: bold,
        italic: italic,
        underline: underline,
    };
}
exports.calculateDefaultFormat = calculateDefaultFormat;
//# sourceMappingURL=calculateDefaultFormat.js.map